const AUTH_TOKEN_COOKIE = 'auth_token'
const VUE_AUTH_REMEMBER_COOKIE = 'rememberMe'
const AUTH_TOKEN_STORAGE_KEY = 'default-auth-token'
const ONE_YEAR_SECONDS = 365 * 24 * 60 * 60

function hasBrowserStorage () {
  return typeof window !== 'undefined' && typeof document !== 'undefined'
}

function getCookie (name) {
  if (!hasBrowserStorage() || !document.cookie) {
    return null
  }

  const cookies = document.cookie.split('; ')

  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i]
    const separatorIndex = cookie.indexOf('=')
    const cookieName = separatorIndex >= 0 ? cookie.slice(0, separatorIndex) : cookie

    if (cookieName === name) {
      const value = separatorIndex >= 0 ? cookie.slice(separatorIndex + 1) : ''

      try {
        return decodeURIComponent(value)
      } catch (e) {
        return value
      }
    }
  }

  return null
}

function setCookie (name, value, maxAgeSeconds) {
  if (!hasBrowserStorage()) {
    return
  }

  const expires = new Date(Date.now() + (maxAgeSeconds * 1000)).toUTCString()
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; max-age=${maxAgeSeconds}; path=/; SameSite=Strict`
}

function deleteCookie (name) {
  if (!hasBrowserStorage()) {
    return
  }

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0; path=/; SameSite=Strict`
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0; domain=${window.location.hostname}; path=/; SameSite=Strict`
}

export function getRememberMeToken () {
  return getCookie(AUTH_TOKEN_COOKIE)
}

export function saveRememberMeToken (token) {
  if (!token) {
    return
  }

  setCookie(AUTH_TOKEN_COOKIE, token, ONE_YEAR_SECONDS)
  setCookie(VUE_AUTH_REMEMBER_COOKIE, 'true', ONE_YEAR_SECONDS)
}

export function restoreRememberMeToken () {
  const token = getRememberMeToken()

  if (token) {
    window.localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token)
    setCookie(VUE_AUTH_REMEMBER_COOKIE, 'true', ONE_YEAR_SECONDS)
  }

  return token
}

export function clearRememberMeToken () {
  deleteCookie(AUTH_TOKEN_COOKIE)
  deleteCookie(VUE_AUTH_REMEMBER_COOKIE)
}

export function clearStoredAuthToken () {
  if (hasBrowserStorage()) {
    window.localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY)
  }
}



// WEBPACK FOOTER //
// ./src/utils/rememberMeAuth.js